import AntMenu from 'antd/lib/menu';

import 'antd/lib/menu/style/index.css';

export default AntMenu;
